import * as React from 'react';
import clx from 'classnames';
import { Col, Typography, Steps, Progress } from 'antd';
const { Step } = Steps;

const { Title, Text } = Typography;
import { SpaceProps } from 'antd/lib/space';
import './ProcedureSteps.scss';

import { IWidgetFormStep } from 'common/schema/widget/disposal/WidgetDisposalStepLogic';
import { PageDesktopOnlyRow } from 'client/ui/layout/page/PageDesktopOnlyRow';
import { VerticalSpace } from 'client/ui/space/VerticalSpace';
import { StepTitleTooltip } from './StepTitleTooltip';

export interface ProcedureStepsProps {
  steps: IWidgetFormStep[];
  currentIndex: number;
}

/**
 *
 */
export function ProcedureSteps(props: ProcedureStepsProps) {
  const { steps, currentIndex } = props;
  return (
    <PageDesktopOnlyRow>
      {steps.length > 3 ? (
        <>
          <Progress
            className="procedure-steps-progress"
            steps={steps.length}
            percent={(100 / steps.length) * (currentIndex + 1)}
            showInfo={false}
          />
          <VerticalSpace size={10} />
          <Text className="procedure-steps-progress-title">
            <span className="number">{currentIndex + 1}</span>
            {steps[currentIndex].title}
          </Text>
        </>
      ) : (
        <Steps
          current={currentIndex}
          size={steps.length > 3 ? 'small' : 'default'}
        >
          {steps.map((step, index) => (
            <Step key={index} title={<StepTitleTooltip title={step.title} />} />
          ))}
        </Steps>
      )}
      <VerticalSpace size={16} />
    </PageDesktopOnlyRow>
  );
}
